// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:51:33

export default {
  "id": "bird-sort-challenges",
  "slug": "bird-sort-challenges",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/316134996d6440048b500131cf4f27d1-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/316134996d6440048b500131cf4f27d1/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Bird Sort Challenges",
      "description": "Bird Sort Challenges  is a fun and relaxing game where you sort colorful birds perched on branches, arranging them by matching colors.\nTest your problem-solving skills as you strategize to ensure no branch overflows and complete each puzzle efficiently.\nWhether you’re looking to unwind or sharpen your mind, Bird Sort: Color Sort Puzzle offers endless entertainment in a cheerful and visually pleasing world.\nGood luck!",
      "instructions": "Tap or mouse click to play!",
      "genres": [
        "Puzzle",
        "Strategy"
      ],
      "tags": [
        "bird",
        "birds",
        "color"
      ]
    },
    "zh-CN": {
      "title": "鸟类排序挑战",
      "description": "《鸟儿排序挑战》是一款有趣且轻松的游戏，您需要在树枝上对五彩斑斓的鸟儿进行排序，按照颜色进行排列。\n在策略性地确保没有树枝溢出的同时，测试您的解决问题的能力，高效地完成每个谜题。\n无论您是想放松身心还是锻炼思维，鸟儿排序：颜色排序拼图游戏在欢快且视觉上令人愉悦的世界中提供无尽的娱乐。\n祝您好运！",
      "instructions": "点击或鼠标点击开始游戏！",
      "genres": [
        "拼图",
        "策略"
      ],
      "tags": [
        "鸟",
        "鸟儿",
        "颜色"
      ]
    },
    "zh-TW": {
      "title": "鳥類排序挑戰",
      "description": "鳥類分類挑戰是一款有趣且放鬆的遊戲，您可以在這個遊戲中將停留在樹枝上的五彩鳥排列整齊，按顏色匹配。\n當您策略性地確保沒有樹枝溢出並高效地完成每個謎題時，考驗您的問題解決能力。\n無論您是想要放鬆身心還是鍛鍊腦力，鳥類分類：顏色排序謎題在快樂且視覺上令人滿意的世界中提供無窮的娛樂。\n祝您幸運！",
      "instructions": "點擊或滑鼠點擊開始遊戲！",
      "genres": [
        "謎題",
        "策略"
      ],
      "tags": [
        "鳥",
        "鳥群",
        "顏色"
      ]
    },
    "zh-HK": {
      "title": "鳥類分類挑戰",
      "description": "鳥類分類挑戰是一款有趣且放鬆的遊戲，遊戲中您需要將停歇在樹枝上的彩色鳥兒按照顏色分類，將他們排列成相同的顏色。\n在您策略性地確保沒有樹枝過滿並高效完成每個謎題的過程中，挑戰您的問題解決能力。\n無論您是想要放鬆心情還是鍛鍊腦力，鳥類分類：顏色分類謎題在這個快樂且視覺效果優美的世界中提供無窮的娛樂。\n祝您順利！",
      "instructions": "點擊或滑鼠按鈕遊玩！",
      "genres": [
        "謎題",
        "策略"
      ],
      "tags": [
        "鳥",
        "鳥群",
        "色彩"
      ]
    },
    "ja": {
      "title": "鳥の並べ替えチャレンジ",
      "description": "バードソート・チャレンジは、色とりどりの鳥を枝に停まったものを色ごとに並べる楽しいリラックス系のゲームです。問題解決能力を試しながら、枝に詰まらないように戦略を立て、それぞれのパズルを効率的に解決しましょう。リラックスしたいときも、頭を鍛えたいときも、バードソート：カラーソートパズルは、明るく視覚的に魅力的な世界で無限の楽しみを提供します。\n幸運を祈っています！",
      "instructions": "タップまたはマウスクリックで遊んでください！",
      "genres": [
        "パズル",
        "戦略"
      ],
      "tags": [
        "鳥",
        "鳥たち",
        "色"
      ]
    },
    "ko": {
      "title": "기鸟类 정렬 도전",
      "description": "박쥐 정렬 도전은 나무 지대에 앉아 있는 다양한 색상의 박쥐를 색상에 맞춰 정렬하는 재미있고 편안한 게임입니다.\n지대가 가득 차지 않도록 전략을 세우며 각 패uzzle를 효율적으로 해결하면서 문제 해결 능력을 테스트하세요.\n쉬고 싶거나 지능을 높이고 싶다면, 박쥐 정렬: 색상 정렬 패uzzle는 밝고 시각적으로 매력적인 세계에서 끝없는 엔터테인먼트를 제공합니다.\n성공하길 바랍니다!",
      "instructions": "게임을 시작하려면 탭이나 마우스 클릭하세요!",
      "genres": [
        "퍼즐",
        "전략"
      ],
      "tags": [
        "새",
        "새들",
        "색상"
      ]
    },
    "fr": {
      "title": "Défis de Tri des Oiseaux",
      "description": "Bird Sort Challenges est un jeu amusant et relaxant où vous classez des oiseaux colorés perchés sur des branches, en les arrangeant par couleurs correspondantes.\nTestez vos compétences en résolution de problèmes tout en stratégisant pour éviter que aucune branche ne déborde et en résolvant chaque puzzle efficacement.\nQue vous cherchiez à vous détendre ou à affiner votre esprit, Bird Sort: Color Sort Puzzle offre un divertissement infini dans un monde joyeux et visuellement agréable.\nBonne chance !",
      "instructions": "Tapez ou cliquez avec la souris pour jouer !",
      "genres": [
        "Puzzle",
        "Stratégie"
      ],
      "tags": [
        "oiseau",
        "oiseaux",
        "couleur"
      ]
    }
  }
};
